import backendVerifiedUser from "../../api/backendVerifiedUser";
import backendValidUserForFile from "../../api/backendVerifiedUserForFile";
import {
  CLOSE_LOADER,
  SET_ERROR,
  SET_LOADER,
  SET_SUCCESS,
} from "../Types/AuthTypes";
import {
  RESET_SPECIFIC_PRODUCT,
  SET_ALL_VARIENTS,
  SET_ARTICLE_NUM,
  SET_OPTION_VALUES,
  SET_PRODUCTS,
  SET_SPECIFIC_PRODUCT,
  SET_SPECIFIC_VARIENTS,
  SET_VARIENT_OPTIONS,
  SET_CUSTOMER_ORDER_REVIEWS,
  SET_CUSTOMER_ORDER_PENDING_REVIEWS,
  SET_CUSTOMER_QUESTIONS,
  SET_MEDIA_CENTER_IMAGES,
  SET_MEDIA_CENTER_VIDEOS,
  SET_PRODUCT_LIST
} from "../Types/ProductTypes";

export const addProduct = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendValidUserForFile.post("/add-product", data);
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const getProducts = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-products");

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_PRODUCTS, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const deleteMultipleProduct = (productIds) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(
        `/delete-multiple-products`,
        productIds
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
    return false;
  };
};

export const getspecificProduct = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(
        `/get-specific-product/${id}`
      );

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SPECIFIC_PRODUCT, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const updateProduct = (data, id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendValidUserForFile.post(
        `/update-product/${id}`,
        data
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      dispatch({ type: RESET_SPECIFIC_PRODUCT });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
    return false;
  };
};

export const getVarientOption = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(`/get-varient-options`);

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_VARIENT_OPTIONS, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const getOptionValues = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(`/get-option-values`);

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_OPTION_VALUES, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const activeMultipleProduct = (productIds) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(
        `/active-multiple-products`,
        productIds
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
    return false;
  };
};
export const updateProductQuantity = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(
        `/update-product-quantity`,
        data
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
    return false;
  };
};

export const deactiveMultipleProduct = (productIds) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(
        `/deactive-multiple-products`,
        productIds
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
    return false;
  };
};

export const toggleProductStatus = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(
        `/toggle-active-product/${id}`
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
    return false;
  };
};
export const toggleFrontpageStatus = (id) => {
  return async (dispatch) => {
    try {
      const response = await backendVerifiedUser.get(`/toggle-frontpage-product/${id}`);
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: SET_ERROR, payLoad: err.response?.data?.error?.msg });
      return false;
    }
  };
};

export const delProductImage = (imgId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(
        `/del-product-image/${imgId}`
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const getRawShootsByProduct = (id) => {
  return async (dispatch) => {
    try {
      const response = await backendVerifiedUser.get(`/get-raw-shoots/${id}`);
      return response.data;
    } catch (err) {
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return [];
    }
  };
};

export const delRawShoot = (fileId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(`/del-raw-shoot/${fileId}`);
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const getspecificVarientsByProduct = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(
        `/get-specific-varients-by-product/${id}`
      );

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SPECIFIC_VARIENTS, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const getAllVarients = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-all-varients");

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_ALL_VARIENTS, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const getArticleNumForProduct = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });

    try {
      const response = await backendVerifiedUser.get(
        "/get-article-num-for-product"
      );

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_ARTICLE_NUM, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const getCustomerOrderReviews = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-customer-order-reviews");
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_CUSTOMER_ORDER_REVIEWS, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const getCustomerOrderPendingReviews = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-customer-order-pending-reviews");
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_CUSTOMER_ORDER_PENDING_REVIEWS, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};
export const sendAdminReview = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post("/send-review-order", data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true ;
    }
    catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  }
}
export const sendAdminQuestion = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post("/send-product-question", data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true ;
    }
    catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  }
}

export const getCustomerQuestions = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-all-product-questions");
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_CUSTOMER_QUESTIONS, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const getTranslation = (data) => {
  return async (dispatch) => {
    try {
      const response = await backendVerifiedUser.post("/get-translation", data);
      return response.data;
    }
    catch (err) {
      console.log(err);
      return false;
    }
  }
}

export const getProductBrands = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-product-brands");
      dispatch({ type: CLOSE_LOADER });
      return response.data;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      return false;
    }
  };
};

export const addProductBrand = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post("/add-product-brand", data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};
export const getAllProductImages = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-all-product-images");
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_MEDIA_CENTER_IMAGES, payLoad: response.data });
      return response.data;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      return false;
    }
  };
};

export const getProductList =()=>{
  return async (dispatch)=>{
    dispatch({type:SET_LOADER})
    try {
     const response = await backendVerifiedUser.get("/product-lists")
     dispatch({type:CLOSE_LOADER})
     dispatch({type:SET_PRODUCT_LIST,payLoad:response.data})
    } catch (error) {
      dispatch({type:CLOSE_LOADER})
      console.log(error)
      dispatch({type:SET_ERROR,payLoad:error.response?.data?.error?.msg})
    }



  }
}

export const updateProductList = (data)=>{
  return async (dispatch)=>{
    dispatch({type:SET_LOADER})
    try {
      const response = await backendVerifiedUser.post("/update-product-list",data)
      dispatch({type:CLOSE_LOADER})
      dispatch({type:SET_SUCCESS,payLoad:response.data.msg})
      return true
    } catch (error) {
      dispatch({type:CLOSE_LOADER})
      console.log(error)
      dispatch({type:SET_ERROR,payLoad:error.response?.data?.error?.msg})
      return false
    }
  }
}
